import { PayrollVoucherStatusEnum } from "@/enum/payroll-voucher-status";

import { PayrollVoucher } from "./types";

const isPending = (voucher: PayrollVoucher): boolean =>
  voucher.status === PayrollVoucherStatusEnum.PENDING;

export const decidedElsewhereSince = (
  previous: readonly PayrollVoucher[],
  current: readonly PayrollVoucher[],
): PayrollVoucher[] => {
  const pendingBefore: Set<number> = new Set(
    previous.filter(isPending).map((voucher: PayrollVoucher): number => voucher.id),
  );

  return current.filter(
    (voucher: PayrollVoucher): boolean =>
      pendingBefore.has(voucher.id) && !isPending(voucher),
  );
};
